import {createSlice} from "@reduxjs/toolkit";

const initialDownloadReport = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  reportList:[],
  userList:[],
  reportDropdownList: [],
  companyList:null,
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const LogDownloadReportSlice = createSlice({
  
  name: "LogDownloadReportSlice",
  initialState: initialDownloadReport,
  
    reducers: {
      catchError: (state, action) => {
        state.error = `${action.type}: ${action.payload.error}`;
        if (action.payload.callType === callTypes.list) {
          state.listLoading = false;
        } else {
          state.actionsLoading = false;
        }
      },
      startCall: (state, action) => {
        state.error = null;
        if (action.payload.callType === callTypes.list) {
          state.listLoading = true;
        } else {
          state.actionsLoading = true;
        }
      },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    logreportList: (state, action) => {
      const { totalCount,entities} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      // state.reportList = reportList;
      // console.log("Report List:", reportList); // Add this console log statement
    },
    UserList: (state, action) => {
      const { userList } = action.payload;
      console.log("entities slice",userList)
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.userList = userList;
    },

    CompanyList: (state, action) => {
      const { companyList } = action.payload;
      console.log("slice companyList",companyList)
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.companyList = companyList;
    },
    ReportDropdownList: (state, action) => {
      const { reportDropdownList } = action.payload;
      console.log("entities slice",reportDropdownList)
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.reportDropdownList = reportDropdownList;
    },
    
  }
});
